// components/LangueInterfaceSelector.jsx
// Sélecteur de langue d'interface, réutilisable (menu de navigation, page profil).

import React from 'react';
import { useLangueInterface } from '../contexts/LangueInterfaceContext';

const LANGUES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
];

export default function LangueInterfaceSelector({ className }) {
  const { langueInterface, setLangueInterface } = useLangueInterface();

  return (
    <select
      className={className}
      value={langueInterface}
      onChange={(e) => setLangueInterface(e.target.value)}
      aria-label="Langue de l'interface"
    >
      {LANGUES.map((l) => (
        <option key={l.code} value={l.code}>
          {l.flag} {l.label}
        </option>
      ))}
    </select>
  );
}
